import React from 'react';
import PropTypes from 'prop-types';

import { Container, Row, Col } from '../../../foundations/Grid';

import { ProfileOutlineCheckmarkWithBorderStyled, HeadingTextStyled, TypographyStyled } from './styles';

export const SubmissionSuccessModule = ({
  descriptionText = null,
  headingText = 'Thank you.',
  themeType = 'lightTheme',
}) => (
  <Container>
    <Row align="center">
      <Col
        xsmall={12}
        align='center'>
        <ProfileOutlineCheckmarkWithBorderStyled $themeType={themeType} />
        <HeadingTextStyled
          component="h3"
          themeType={themeType}
        >
          {headingText}
        </HeadingTextStyled>
        {descriptionText
        && <TypographyStyled
          themeType={themeType}>
          {descriptionText}
        </TypographyStyled>
        }
      </Col>
    </Row>
  </Container>
);

SubmissionSuccessModule.propTypes = {
  /** Error Subtext (additional error supporting text) below heading */
  descriptionText: PropTypes.string,
  /** Required Error heading describing main submission error */
  headingText: PropTypes.string.isRequired,
  /** Optional themeType */
  themeType: PropTypes.oneOf(['lightTheme', 'darkTheme', 'nmx-pcg']),
};

export default SubmissionSuccessModule;
